export const fieldsEditGuideline = [
  {    
    title: 'Titulo*',
    field: 'titulo',
    type: 'text',
    boolType: false,
    component: 'text',
    placeholder: '',
  },
  {    
    title: 'Cidade',
    field: 'cidade',
    boolType: false,
    component: 'select',
    disable: true,
  },
  {    
    title: 'Ativo*',
    field: 'active',
    type: 'select',
    boolType: true,
    component: 'select',
  },
];